// src/pages/MisReportes.js
import React, { useState, useEffect } from 'react';
import { listarMisFeedbacks } from '../services/api';

const MisReportes = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarMisFeedbacks();
  }, []);

  const cargarMisFeedbacks = async () => {
    setLoading(true);
    try {
      const response = await listarMisFeedbacks();
      setFeedbacks(response.data.feedbacks);
    } catch (error) {
      console.error('Error cargando feedbacks:', error);
    } finally {
      setLoading(false);
    }
  };

  const getEstadoClass = (estado) => {
    const clases = {
      'pendiente': 'estado-pendiente',
      'en_proceso': 'estado-proceso',
      'resuelto': 'estado-resuelto',
      'rechazado': 'estado-rechazado'
    };
    return clases[estado] || '';
  };

  const getTipoIcono = (tipo) => {
    const iconos = {
      'bug': '🐛',
      'sugerencia': '💡',
      'mejora': '✨',
      'general': '💬'
    };
    return iconos[tipo] || '📌';
  };

  if (loading) return <div className="loading">Cargando tus reportes...</div>;

  return (
    <div className="mis-reportes">
      <h1>📢 Mis Reportes y Sugerencias</h1>
      
      {feedbacks.length === 0 ? (
        <div className="empty-state">
          <p>No has enviado ningún reporte todavía.</p>
          <p>Usa el botón flotante 💬 para enviar tu primer feedback.</p>
        </div>
      ) : (
        <div className="reportes-list">
          {feedbacks.map(f => (
            <div key={f.id} className="reporte-card">
              <div className="reporte-header">
                <div className="reporte-titulo">
                  <span className="reporte-icon">{getTipoIcono(f.tipo)}</span>
                  <h3>{f.titulo}</h3>
                </div>
                <span className={`reporte-estado ${getEstadoClass(f.estado)}`}>
                  {f.estado === 'pendiente' && '⏳ Pendiente'}
                  {f.estado === 'en_proceso' && '🔄 En revisión'}
                  {f.estado === 'resuelto' && '✅ Resuelto'}
                  {f.estado === 'rechazado' && '❌ No procede'}
                </span>
              </div>

              <div className="reporte-meta">
                <span>📅 {new Date(f.created_at).toLocaleString()}</span>
                <span className={`prioridad-${f.prioridad}`}>
                  🚩 Prioridad {f.prioridad}
                </span>
              </div>

              <div className="reporte-descripcion">
                {f.descripcion}
              </div>

              {f.respuesta_admin && (
                <div className="reporte-respuesta">
                  <strong>👤 Respuesta del equipo:</strong>
                  <p>{f.respuesta_admin}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MisReportes;